import React, { useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import LoaderWrapper from "../loaders/loader";

function hasAuthCallbackParams() {
  const sp = new URLSearchParams(window.location.search);
  return (sp.has("code") && sp.has("state")) || sp.has("error");
}

function getAuth0ErrorInfo(err: any) {
  const code = err?.error || err?.code || err?.name; // suele ser "access_denied"
  const message = err?.error_description || err?.message || "";
  return { code, message };
}

export default function AuthGate({ children }: { children: React.ReactNode }) {
  const { isLoading, isAuthenticated, error, loginWithRedirect, logout } = useAuth0();

  const didRedirect = useRef(false);
  const didLogout = useRef(false);

  useEffect(() => {
    if (isLoading) return;

    // Si hay error, decide acción
    if (error) {
      const { code, message } = getAuth0ErrorInfo(error);

      const isInvalidIP =
        code === "access_denied" && message.toLowerCase().includes("invalid ip");

      if (isInvalidIP && !didLogout.current) {
        didLogout.current = true;

        // Limpia query params para evitar re-procesar el callback
        window.history.replaceState({}, document.title, window.location.pathname);

        // Logout (SSO opcional)
        logout();
      }

      return; // ✅ importantísimo: no autologin cuando hay error
    }

    // ✅ Si vienes de callback, no relanzar login
    if (hasAuthCallbackParams()) return;

    // ✅ Autologin una sola vez
    if (!isAuthenticated && !didRedirect.current) {
      didRedirect.current = true;
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, error, loginWithRedirect, logout]);

  if (isLoading || !isAuthenticated) return <LoaderWrapper />;

  return <>{children}</>;
}
